import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AlertDialogOptions } from '../../models/alert-dialog-options.model';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'work-ui-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: true,
  imports: [NgClass, IconComponent, ButtonComponent, TranslateModule],
})
export class AlertDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input({ required: true }) alertDialogOptions!: AlertDialogOptions;

  @Output() beforeClose = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  public stateIconName = '';
  public isVisible = true;

  private autoCloseTimeoutId?: ReturnType<typeof setTimeout>;

  ngOnInit() {
    switch (this.alertDialogOptions.feedbackState) {
      case 'success': {
        this.stateIconName = 'check';
        break;
      }
      case 'warning': {
        this.stateIconName = 'campaign';
        break;
      }
      case 'error': {
        this.stateIconName = 'report';
        break;
      }
    }

    if (!this.alertDialogOptions.alertLifeTimeInMs) {
      this.alertDialogOptions.alertLifeTimeInMs = 4000;
    }
  }

  ngAfterViewInit() {
    this.startAutoCloseTimer();
  }

  ngOnDestroy() {
    this.clearAutoCloseTimer();
  }

  /**
   * Solange die Maus über dem Alert liegt oder der Fokus darin ist, wird nicht automatisch
   * geschlossen — sonst verschwindet die Meldung, während man sie liest oder ihre Aktion anklickt.
   */
  pauseAutoClose(): void {
    this.clearAutoCloseTimer();
  }

  /**
   * Nach dem Verlassen läuft die volle Anzeigedauer neu (nicht die Restzeit), damit nach dem Lesen
   * nicht plötzlich nur noch Millisekunden übrig sind.
   */
  resumeAutoClose(): void {
    if (!this.isVisible) {
      return;
    }
    this.startAutoCloseTimer();
  }

  close(): void {
    this.clearAutoCloseTimer();
    this.isVisible = false;
    this.beforeClose.emit();
    // Wait for animation to end
    setTimeout(() => {
      this.closed.emit();
    }, 250);
  }

  executeAction(): void {
    if (this.alertDialogOptions.actionHandler) {
      this.alertDialogOptions.actionHandler();
      this.close();
    }
  }

  private startAutoCloseTimer(): void {
    this.clearAutoCloseTimer();
    this.autoCloseTimeoutId = setTimeout(() => {
      this.close();
    }, this.alertDialogOptions.alertLifeTimeInMs);
  }

  private clearAutoCloseTimer(): void {
    if (this.autoCloseTimeoutId) {
      clearTimeout(this.autoCloseTimeoutId);
      this.autoCloseTimeoutId = undefined;
    }
  }
}
